//This component should be a list of trending arguments and argument categories.


import TopNavigation from "../../components/TopNavigation";
import Trending from "../../components/Trending/Trending";
import BottomNavigation from "../../components/BottomNavigation";

function Dashboard () {
    return(
        <>
        <div className="p-4 pb-20">
            <TopNavigation />
            <p className="text-center text-white text-md my-2 bg-blue-900 rounded-md p-2 text-lg">"I went straight to the comment section and didn't regret it" - Ancient American Proverb</p>
            <div className="flex flex-col h-full overflow-y-auto">
            <Trending />
            </div>
        </div>
        <BottomNavigation />
        </>
    )
}

export default Dashboard;